(function () {
  if (window.productBuyBehaviorLoaded) return;
  window.productBuyBehaviorLoaded = true;
  var STICKY_AT = 1000;
  var ATC_TIMEOUT_MS = 6000;
  var ATC_POLL_MS = 120;









  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!item.classList || !item.classList.contains('product-faq__item')) return;
    var icon = item.querySelector('.product-faq__icon');
    if (icon) icon.textContent = item.open ? '−' : '+';
  }, true);

  function formFor(trigger) {
    return trigger.dataset.form ? document.getElementById(trigger.dataset.form) : null;
  }

  function relocateStickyBars() {
    document.querySelectorAll('.product-quick-add').forEach(function (bar) {
      var button = bar.querySelector('.sticky-atc-btn');
      if (!button || button.type === 'submit' || bar.parentElement === document.body) return;
      var owner = bar.closest('.shopify-section');
      if (owner) bar.dataset.stickySection = owner.id;
      document.body.appendChild(bar);
    });
  }

  function syncSticky() {
    var visible = window.scrollY > STICKY_AT;
    var height = 0;
    document.querySelectorAll('.product-quick-add').forEach(function (bar) {
      bar.classList.toggle('sticky-added', visible);
      if (visible) height = Math.max(height, bar.getBoundingClientRect().height);
    });
    document.documentElement.style.setProperty('--product-quick-add-height', height + 'px');
  }

  function removeRelocatedBars(event) {
    document.querySelectorAll('body > .product-quick-add').forEach(function (bar) {
      if (bar.dataset.stickySection === event.target.id) bar.remove();
    });
    syncSticky();
  }

  var stickyFrame = null;
  function scheduleStickySync() {
    if (stickyFrame !== null) return;
    stickyFrame = requestAnimationFrame(function () {
      stickyFrame = null;
      syncSticky();
    });
  }

  relocateStickyBars();
  window.addEventListener('scroll', scheduleStickySync, { passive: true });
  window.addEventListener('resize', scheduleStickySync, { passive: true });
  document.addEventListener('shopify:section:unload', removeRelocatedBars);
  document.addEventListener('shopify:section:load', function (event) {
    removeRelocatedBars(event);
    relocateStickyBars();
    syncSticky();
  });
  syncSticky();

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.sticky-atc-btn');
    if (!trigger || trigger.type === 'submit' || trigger.hasAttribute('data-offer-checkout')) return;
    event.preventDefault();
    var form = formFor(trigger);
    var scope = form && form.closest('.product-buy');
    var offer = scope && scope.querySelector('[data-pack-picker]');
    if (!offer) offer = document.getElementById('pack-picker-offer');
    if (offer) offer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  function showPurchaseError(form, message) {
    var wrapper = form.closest('product-form');
    var error = wrapper && wrapper.querySelector('.product-form__error-message');
    if (error) {
      error.textContent = message;
      error.parentElement.hidden = false;
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.one-time-btn');
    if (!trigger || trigger.type === 'submit' || trigger.hasAttribute('data-offer-checkout')) return;
    event.preventDefault();
    if (trigger.dataset.pending) return;
    var form = formFor(trigger);
    if (!form) return;
    var scope = trigger.closest('.product-buy-section, .shopify-section');
    var selector = trigger.dataset.oneTimeSelector;
    var option;
    try { option = selector && scope && scope.querySelector(selector); }
    catch (error) {
      showPurchaseError(form, 'The one-time purchase option is unavailable. Please use the purchase options above.');
      return;
    }
    if (option) {
      option.click();
    } else if (!selector && scope) {
      var loopOneTime = scope.querySelector('[data-loop-widget-onetime-purchase-option]');
      if (loopOneTime && loopOneTime.getAttribute('aria-checked') !== 'true') loopOneTime.click();
      var checkbox = scope.querySelector('.kaching-bundles__subscriptions__checkbox');

      if (checkbox && checkbox.querySelector('svg')) checkbox.click();
    }
    trigger.dataset.pending = 'true';
    trigger.disabled = true;
    var startedAt = Date.now();
    function submitWhenReady() {
      var plan = new FormData(form).get('selling_plan');
      var submit = form.querySelector('.product-form__submit');
      if (!plan && submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true' && !submit.classList.contains('loading')) {
        delete trigger.dataset.pending;
        trigger.disabled = false;
        submit.click();
      } else if (Date.now() - startedAt > ATC_TIMEOUT_MS || !trigger.isConnected) {
        delete trigger.dataset.pending;
        trigger.disabled = false;
        showPurchaseError(form, 'Please select One Time Purchase above before adding this item.');
      } else {
        setTimeout(submitWhenReady, ATC_POLL_MS);
      }
    }
    submitWhenReady();
  });





  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function nextCutoff(hour, from) {
    var cutoff = new Date(from);
    cutoff.setHours(hour, 0, 0, 0);
    if (cutoff <= from) cutoff.setDate(cutoff.getDate() + 1);
    return cutoff;
  }

  function syncDeliveryCountdowns() {
    var now = new Date();
    document.querySelectorAll('[data-buy-perk-countdown]').forEach(function (el) {
      var hour = parseInt(el.dataset.cutoffHour, 10);
      var days = parseInt(el.dataset.deliveryDays, 10);
      if (isNaN(hour) || isNaN(days)) return;

      var cutoff = nextCutoff(hour, now);
      var left = Math.max(0, Math.floor((cutoff - now) / 1000));
      el.textContent =
        pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);



      var stamp = String(cutoff.getTime());
      if (el.dataset.etaFor === stamp) return;
      var eta = el.parentNode.querySelector('[data-buy-perk-eta]');
      if (!eta) return;
      el.dataset.etaFor = stamp;
      var arrives = new Date(cutoff);
      arrives.setDate(arrives.getDate() + days);
      try {
        eta.textContent = arrives.toLocaleDateString(undefined, {
          weekday: 'long',
          month: 'long',
          day: 'numeric',
        });
      } catch (e) {

      }
    });
  }

  {
    var ticker = null;

    function startTicking() {
      if (ticker) return;
      syncDeliveryCountdowns();
      ticker = setInterval(syncDeliveryCountdowns, 1000);
    }

    function stopTicking() {
      clearInterval(ticker);
      ticker = null;
    }



    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTicking();
      else startTicking();
    });

    document.addEventListener('shopify:section:load', function () {
      if (!document.hidden) startTicking();
      syncDeliveryCountdowns();
    });
    if (!document.hidden) startTicking();
  }
})();
